import api from "../../../services/api.service"


export const whitelabelModule = {
    namespaced: true,
    state: {
        data: {types: [], categories: []},
    },
    getters: {
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },
        allStatusNoActive() {
            return [
                {value: "NEW", text: 'NEW'},
                {value: 'EXPOSE', text: 'EXPOSE'},
                {value: 'DISABLED', text: 'DISABLED'}
            ]
        },
        allStatus() {
            return [
                {value: "NEW", text: 'NEW'},
                {value: 'EXPOSE', text: 'EXPOSE'},
                {value: 'ACTIVE', text: 'ACTIVE'},
                {value: 'DISABLED', text: 'DISABLED'}
            ]
        },


    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {


        getAllWhitelabel(actions, {page, amount, filter, sortcolumn, sortby}) {

            return new Promise(function (resolve, reject) {
                api.sendRequest('whitelabel/get', {
                    buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                    page,
                    amount,
                    sortcolumn,
                    sortby
                }, filter).then(
                    (ans) => {
                        if (ans["Whitelabels"] == null)
                            return reject('Could not get Whitelabel ');

                        resolve(ans);
                    }, (error) => {
                        reject(error.message)
                    })
            })

        },

        getWhitelabelById(actions, id) {
            return new Promise((resolve, reject) => {

                api.sendRequest('whitelabel/id/' + id).then(
                    (ans) => {

                        if (ans["Whitelabel"] == null)
                            return reject('Could not get whitelabel ');

                        resolve(ans["Whitelabel"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },


        updateWhitelabel(actions, whitelabel) {
            return new Promise((resolve, reject) => {

                api.sendRequest('whitelabel/update', null, whitelabel).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update whitelabel', message: 'Whitelabel updated successfully'},
                            {root: true});

                        if (ans["Whitelabel"] == null)
                            return reject('Could not update whitelabel ');

                        resolve(ans["Whitelabel"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        addWhitelabel(actions, defaultWhitelabel) {
            return new Promise((resolve, reject) => {
                api.sendRequest('whitelabel/add', null, defaultWhitelabel).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Add whitelabel', message: 'Whitelabel created successfully'},
                            {root: true});

                        if (ans["WhitelabelId"] == null)
                            return reject('Could not create whitelabel ');

                        console.log("whitelabel answer created: ", ans)
                        resolve(ans["WhitelabelId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        }

    },
};
